import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import escapeStringRegex from 'escape-string-regexp';

var Mark = function Mark(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["children", "className"]);

  return /*#__PURE__*/React.createElement("span", _extends({
    className: classNames('cloud-ui-search-result-mark', className)
  }, props), children);
};

var DefaultWrapper = function DefaultWrapper(props) {
  return /*#__PURE__*/React.createElement("a", props, props.children);
};

var safeRegExp = function safeRegExp(phrase, options) {
  try {
    return new RegExp(phrase, options);
  } catch (error) {
    return new RegExp(escapeStringRegex(phrase), options);
  }
};

var SearchEntity = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchEntity, _React$Component);

  var _super = _createSuper(SearchEntity);

  function SearchEntity() {
    var _this;

    _classCallCheck(this, SearchEntity);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "singlePhraseRegexp", function (name, phrase) {
      var regexp = safeRegExp(phrase.replace(/\s/g, '.*'), 'gi'); // multiple case-insensitive matches may not be identical

      var originalMatches = name.match(regexp);
      var splitName = name.split(regexp);
      var index = 1;
      var markedMatch;

      while (index < splitName.length) {
        markedMatch = _this.phraseMark(originalMatches.shift());
        splitName.splice(index, 0, markedMatch); // inserting matching phrase

        index += 2; //index increased with inserted element
      }

      return splitName;
    });

    _defineProperty(_assertThisInitialized(_this), "combinedRegexp", function (name, phrase) {
      var splitName = [];
      var partedName = name;
      var match, preceding;
      phrase.split(' ').forEach(function (part) {
        if (part) {
          var regexp = safeRegExp(part, 'i');
          match = partedName.match(regexp);

          if (match) {
            preceding = partedName.split(regexp)[0];
            splitName.push(preceding, _this.phraseMark(match[0]));
            partedName = partedName.substr(preceding.length + match[0].length);
          }
        }
      });
      splitName.push(partedName);
      return splitName;
    });

    _defineProperty(_assertThisInitialized(_this), "phraseMark", function (phrase) {
      return /*#__PURE__*/React.createElement(Mark, null, phrase);
    });

    return _this;
  }

  _createClass(SearchEntity, [{
    key: "markedResult",
    value: function markedResult(phrase, name) {
      if (phrase.includes(' ')) {
        return this.combinedRegexp(name, phrase);
      } else {
        return this.singlePhraseRegexp(name, phrase);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          searchPhrase = _this$props.searchPhrase,
          name = _this$props.name,
          _this$props$Wrapper = _this$props.Wrapper,
          Wrapper = _this$props$Wrapper === void 0 ? DefaultWrapper : _this$props$Wrapper,
          rest = _objectWithoutProperties(_this$props, ["searchPhrase", "name", "Wrapper"]);

      var clearPhrase = searchPhrase.replace(/\*/g, '');
      var results = this.markedResult(clearPhrase, name);
      return /*#__PURE__*/React.createElement(Wrapper, _extends({
        className: "cloud-ui-search-result-entity"
      }, rest), results.map(function (item, i) {
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: i
        }, item);
      }));
    }
  }]);

  return SearchEntity;
}(React.Component);

_defineProperty(SearchEntity, "propTypes", {
  searchPhrase: PropTypes.string,
  name: PropTypes.string,
  Wrapper: PropTypes.func
});

export { SearchEntity as default };